import { Capacitor, registerPlugin } from '@capacitor/core';

type PrivacyScreenPlugin = {
	suspend: () => Promise<void>;
	resume: () => Promise<void>;
};

/** Implemented in the iOS app target (ios/App/App/PrivacyScreen.swift); no other platform has it. */
const PrivacyScreen = registerPlugin<PrivacyScreenPlugin>('PrivacyScreen');

const ignore = () => {};

/**
 * Runs an OS prompt with the app-switcher cover held back. Face ID makes the scene inactive, and the
 * cover would otherwise replace the app behind the prompt with the splash on every unlock.
 */
export async function withPrivacyScreenSuspended<T>(prompt: () => Promise<T>): Promise<T> {
	if (!Capacitor.isPluginAvailable('PrivacyScreen')) {
		return prompt();
	}

	await PrivacyScreen.suspend().catch(ignore);
	try {
		return await prompt();
	} finally {
		PrivacyScreen.resume().catch(ignore);
	}
}
